import { useKeycloak } from "@react-keycloak/web";

const PrivateRoute = ({roles, children }) => {
 console.log("roles")
 console.log(roles)
 console.log("children")
 console.log(children)
 const { keycloak } = useKeycloak();
 console.log("keycloak")
 console.log(keycloak)
 const isLoggedIn = keycloak.authenticated;

 if(isLoggedIn)
 {                        //vv COMMENT OUT console.log(...)
    if (roles.some(r => { console.log(r); return(keycloak.hasResourceRole(r)); })) {
        console.log("true but down"); //<<- COMMENT OUT console.log(...)
        return children;  
    }
}
else
{
    return null;
}
    
    //return isLoggedIn ? children : null;
}
export default PrivateRoute;